<template>
  <div>
    <ProcurePageDetail></ProcurePageDetail>
  </div>
</template>
<script>
export default {
    name: 'PurchaseDetail',
    data () {
        return {
            
        }	 
    },
    filters: {
      
    },
    components: {
        ProcurePageDetail: resolve => require(["@/components/InvoiceManage/ProcurePageDetail.vue"],resolve),
    },
    watch:{
        
    },
    methods: {
    },
    //============================================== 生命周期 ==============================================
    created() {
    },
    mounted () {
    },
    destroyed(){
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/InvoiceManage/PurchaseDetail.vue